import React from 'react'
import PropTypes from 'prop-types'
import { usePanelPartDrag } from 'hooks/dash'
import { useSelector } from 'hooks/redux'
import { getDashVehicleSerialNumber } from 'selectors/dash'

const DraggableRef = ({ location, children }) => {
  const serialNumber = useSelector(getDashVehicleSerialNumber)

  const { dragRef, isDraggable } = usePanelPartDrag({
    location,
    serialNumber,
  })

  if (!isDraggable) return <div>{children}</div>

  return <div ref={dragRef}>{children}</div>
}

DraggableRef.propTypes = {
  children: PropTypes.any,
  location: PropTypes.string,
}

export default DraggableRef
